<template>
  <div
    :class="{
      'active-file': file.isActiveState,
      checked: file.isCheckedState,
    }"
    class="download-box file-box"
    @click="onIconClick">
    <download-button
      v-if="file.isDownloadAllowed"
      ref="downloadButton"
      :item="file"
      :is-encrypted="isEncrypted"
      @click.stop />
    <div
      :data-id="file.id"
      class="preview-area d-flex align-center">
      <template v-if="isEncrypted || file.nopreview">
        <span
          :class="iconClass"
          class="preview-icons w-100" />
      </template>
      <img
        v-else
        :src="file.previewLink"
        :alt="filePreviewAlt"
        class="preview"
        @error="onErrorIcon(file)">
    </div>
    <div class="file-meta-container d-flex justify-space-between align-center">
      <div class="file-meta">
        <div
          :title="file.name"
          class="file-name">
          {{ file.name }}
        </div>
        <span class="file-size">{{ fileBytes }}</span>
      </div>
      <qx-checkbox
        v-if="file.isDownloadAllowed"
        class="check-item"
        :checked="file.isCheckedState"
        @onChange="onCheckboxChange"
        @click.self="handleClick" />
    </div>
  </div>
</template>

<script>
import downloadButton from '@/elements/download/downloadButton.vue';
import QxCheckbox from '@/elements/form/QxCheckbox.vue';

import { getByExtension } from '@/utils/fileIcons.js';
import { getFileSize } from '@/utils/filters.js';

export default {
  name: 'FileGridItem',
  components: {
    downloadButton,
    QxCheckbox,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
    isEncrypted: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click', 'changeCheckedState'],
  data() {
    return {
      filePreviewAlt: this.$gettext('File preview'),
    };
  },
  computed: {
    fileSize() {
      return getFileSize(this.file?.size);
    },
    fileBytes() {
      return getFileSize(this.file?.bytes);
    },
    iconClass() {
      return getByExtension(this.file?.ftype).icon;
    },
  },
  methods: {
    onErrorIcon(file) {
      file.nopreview = true;
    },
    onIconClick({ ctrlKey, metaKey, shiftKey }) {
      this.$emit('click', { isCtrl: ctrlKey || metaKey, isShift: shiftKey });
    },
    onCheckboxChange() {
      this.$emit('changeCheckedState', this.file);
    },
    handleClick(event) {
      if (!event.shiftKey) {
        event.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-box {
  height: 275px;
  &:hover,
  &.active-file {
    .download-button {
      display: flex !important;
    }
  }
  .download-button {
    display: none !important;
    position: absolute;
    z-index: 1000;
    margin: 10px;
  }
  .preview-area {
    height: 210px;
    text-align: center;
    .preview-icons {
      max-height: 100px;
      margin: 24px 0;
      color: silver;
      &.file-list-icon {
        width: 100% !important;
        height: 100% !important;
        background-position-x: center;
      }
    }
    .file-counter {
      font-size: 24px;
      left: 62px;
      top: 60px;
      position: absolute;
      color: silver;
    }
    .preview {
      max-height: 100%;
      max-width: 100%;
      vertical-align: middle;
      margin: 0 auto;
    }
  }
  .file-meta-container {
    padding: 10px 15px;
    .file-meta {
      width: 80%;
    }
  }
}
</style>
